import { render, staticRenderFns } from "./ProjTaskList.vue?vue&type=template&id=24c942a0"
import script from "./ProjTaskList.vue?vue&type=script&lang=js"
export * from "./ProjTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports